import React from 'react';
import { Companies } from './blocks';
import { CompanyDetailsData } from '@/pages/buddy/types/CompanyDetailsData';

interface CompaniesContentProps {
    companies: CompanyDetailsData[];
    loading: boolean;
    on_delete: (companyId: string) => void; // Add the on_delete prop
}

const CompaniesContent: React.FC<CompaniesContentProps> = ({
                                                               companies,
                                                               loading,
                                                               on_delete, // Pass down the on_delete prop
                                                           }) => {
    return (
        <div>
            <Companies
                companies={companies}
                loading={loading}
                on_delete={on_delete} // Pass the on_delete prop to Companies
            />
        </div>
    );
};

export { CompaniesContent };
